import React from "react";
import PropTypes from "prop-types";
import FrequentlyAskedQuestions from "../../../../../../../components/FrequentlyAskedQuestions/FrequentlyAskedQuestions";

const propTypes = {
  t: PropTypes.func.isRequired,
  faqData: PropTypes.array.isRequired,
};

const Faq = ({ t, faqData }) => (
  <section
    className="LandingPage-section LandingPage-Faq"
    data-testid="LandingPage-Faq"
  >
    <h2 className="LandingPage-Faq-heading">
      {t("spages.referrals.landing.sections.Faq.title")}
    </h2>
    <FrequentlyAskedQuestions content={faqData} t={t} />
  </section>
);

Faq.propTypes = propTypes;
export default Faq;
